<app-error-display-banner
  *ngIf="displayErrorBanner"
  class="global-error-banner"
>
</app-error-display-banner>

<div
  [ngClass]="displayVisualAid ? 'visual_aid_enabled' : 'visual_aid_disabled'"
  [class.no-hint]="!callStore.getHints()"
>
  <div class="inner">
    <div class="avatar">
      <ng-content select="[avatarSlot]" />
    </div>
    <div class="hint">
      <ng-content select="[hintSlot]" />
    </div>
    <div class="user" *ngIf="!displayVisualAid">
      <ng-content select="[userSlot]" />
    </div>
    <div class="visual_aid" *ngIf="!!displayVisualAid">
      <ng-content
        select="[visualAidSlot]"
        (visualAidClick)="handleVisualAidClick()"
      />
    </div>

    <div class="visual_aid_button" *ngIf="!displayVisualAid">
      <div class="flex_wrapper">
        <button
          qai-button
          [kind]="'tertiary'"
          [size]="'medium'"
          (click)="handleVisualAidClick()"
          [disabled]="!enableVisualAid"
        >
          <qai-icon kind="eye" positionStart />
          Display visual aid
        </button>
      </div>
    </div>

  </div>
</div>
